'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = options;

var _updeep = require('updeep');

var _updeep2 = _interopRequireDefault(_updeep);

var _constants = require('../constants');

var _expires2 = require('../status/_expires');

var _expires3 = _interopRequireDefault(_expires2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function options(root, listName, opts) {
    if (opts && opts.total === 0 && !opts.state) {
        opts = (0, _extends3.default)({}, opts, {
            expires: (0, _expires3.default)(opts),
            state: _constants.OK
        });
    }

    return (0, _updeep2.default)({
        list: (0, _defineProperty3.default)({}, listName, opts)
    }, root || {});
}